export const DASHBOARD_DATE_FORMAT = 'll';
export const URL_DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_FIELD_FORMAT = 'YYYY-MM-DD';